module.exports = __webpack_public_path__ + "static/media/ganesha-ji-diya-1.f9299128.gif";